const orders = {
    title: 'Jouw Bestellingen',
    errorLoading: 'Fout bij laden bestellingen',
    noOrders: 'Geen bestellingen gevonden',
    noOrdersMessage: 'Je hebt nog geen productbestellingen geplaatst',
    orderId: 'Bestelnummer',
    orderedOn: 'Besteld op',
    quantity: 'Hoeveelheid',
    each: 'elk',
    total: 'Totaal',
    orderTimeline: 'Bestelhistorie',
    paidOn: 'Betaald op',
    shippedOn: 'Verzonden op',
    deliveredOn: 'Afgeleverd op',
    cancelledOn: 'Geannuleerd op',
    statusPending: 'In afwachting',
    statusPaid: 'Betaald',
    statusShipped: 'Verzonden',
    statusDelivered: 'Afgeleverd',
    statusCancelled: 'Geannuleerd'
};

export default orders;

